import React from "react";
import Modal from "../../../../elements/Modal";
import ManageTestimonials from "../ManageTestimonials";
import Drawer from "../../../../elements/Drawer";

const ManageTestimonialsModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    // <Modal
    //   isOpen={open}
    //   setIsOpen={close}
    //   size="xl2"
    //   title={data?._id ? "Update" : "Create New "}
    // >
    //   <ManageTestimonials getResponse={getResponse} close={close} data={data} />
    // </Modal>
    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl"}
      title={data?._id ? "Update" : "Create New "}
      subtitle="View, update and modify Testimonials details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      // header={<DrawerHeader />}
    >
      <ManageTestimonials getResponse={getResponse} close={close} data={data} />
    </Drawer>
  );
};

export default ManageTestimonialsModal;
